/**
 * Convert the given array buffer into a Base64URL-encoded string. Ideal for converting various
 * credential response ArrayBuffers to string for sending back to the server as JSON.
 *
 * Helper method to compliment `base64URLStringToBuffer`
 */ function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _create_for_of_iterator_helper_loose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = _unsupported_iterable_to_array(o)) || allowArrayLike) {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) {
                return {
                    done: true
                };
            }
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function bufferToBase64URLString(buffer) {
    var bytes = new Uint8Array(buffer);
    var str = '';
    for(var _iterator = _create_for_of_iterator_helper_loose(bytes), _step; !(_step = _iterator()).done;){
        var charCode = _step.value;
        str += String.fromCharCode(charCode);
    }
    var base64String = btoa(str);
    return base64String.replace(/\+/g, '-').replace(/\//g, '_').replace(/=/g, '');
}

/**
 * Convert from a Base64URL-encoded string to an Array Buffer. Best used when converting a
 * credential ID from a JSON string to an ArrayBuffer, like in allowCredentials or
 * excludeCredentials
 *
 * Helper method to compliment `bufferToBase64URLString`
 */ function base64URLStringToBuffer(base64URLString) {
    // Convert from Base64URL to Base64
    var base64 = base64URLString.replace(/-/g, '+').replace(/_/g, '/');
    /**
     * Pad with '=' until it's a multiple of four
     * (4 - (85 % 4 = 1) = 3) % 4 = 3 padding
     * (4 - (86 % 4 = 2) = 2) % 4 = 2 padding
     * (4 - (87 % 4 = 3) = 1) % 4 = 1 padding
     * (4 - (88 % 4 = 0) = 4) % 4 = 0 padding
     */ var padLength = (4 - base64.length % 4) % 4;
    var padded = base64.padEnd(base64.length + padLength, '=');
    // Convert to a binary string
    var binary = atob(padded);
    // Convert binary string to buffer
    var buffer = new ArrayBuffer(binary.length);
    var bytes = new Uint8Array(buffer);
    for(var i = 0; i < binary.length; i++){
        bytes[i] = binary.charCodeAt(i);
    }
    return buffer;
}

/**
 * Determine if the browser is capable of Webauthn
 */ function browserSupportsWebAuthn() {
    var _globalThis;
    return _browserSupportsWebAuthnInternals.stubThis(((_globalThis = globalThis) == null ? void 0 : _globalThis.PublicKeyCredential) !== undefined && typeof globalThis.PublicKeyCredential === 'function');
}
/**
 * Make it possible to stub the return value during testing
 * @ignore Don't include this in docs output
 */ var _browserSupportsWebAuthnInternals = {
    stubThis: function(value) {
        return value;
    }
};

function _extends$2() {
    _extends$2 = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends$2.apply(this, arguments);
}
function toPublicKeyCredentialDescriptor(descriptor) {
    var id = descriptor.id;
    return _extends$2({}, descriptor, {
        id: base64URLStringToBuffer(id),
        /**
         * `descriptor.transports` is an array of our `AuthenticatorTransportFuture` that includes newer
         * transports that TypeScript's DOM lib is ignorant of. Convince TS that our list of transports
         * are fine to pass to WebAuthn since browsers will recognize the new value.
         */ transports: descriptor.transports
    });
}

/**
 * A simple test to determine if a hostname is a properly-formatted domain name
 *
 * A "valid domain" is defined here: https://url.spec.whatwg.org/#valid-domain
 *
 * Regex sourced from here:
 * https://www.oreilly.com/library/view/regular-expressions-cookbook/9781449327453/ch08s15.html
 */ function isValidDomain(hostname) {
    return(// Consider localhost valid as well since it's okay wrt Secure Contexts
    hostname === 'localhost' || /^([a-z0-9]+(-[a-z0-9]+)*\.)+[a-z]{2,}$/i.test(hostname));
}

/**
 * A custom Error used to return a more nuanced error detailing _why_ one of the eight documented
 * errors in the spec was raised after calling `navigator.credentials.create()` or
 * `navigator.credentials.get()`:
 *
 * - `AbortError`
 * - `ConstraintError`
 * - `InvalidStateError`
 * - `NotAllowedError`
 * - `NotSupportedError`
 * - `SecurityError`
 * - `TypeError`
 * - `UnknownError`
 *
 * Error messages were determined through investigation of the spec to determine under which
 * scenarios a given error would be raised.
 */ function _construct(Parent, args, Class) {
    if (_is_native_reflect_construct()) {
        _construct = Reflect.construct;
    } else {
        _construct = function construct(Parent, args, Class) {
            var a = [
                null
            ];
            a.push.apply(a, args);
            var Constructor = Function.bind.apply(Parent, a);
            var instance = new Constructor();
            if (Class) _set_prototype_of(instance, Class.prototype);
            return instance;
        };
    }
    return _construct.apply(null, arguments);
}
function _get_prototype_of(o) {
    _get_prototype_of = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _get_prototype_of(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _set_prototype_of(subClass, superClass);
}
function _is_native_function(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}
function _set_prototype_of(o, p) {
    _set_prototype_of = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _set_prototype_of(o, p);
}
function _wrap_native_super(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    _wrap_native_super = function wrapNativeSuper(Class) {
        if (Class === null || !_is_native_function(Class)) return Class;
        if (typeof Class !== "function") {
            throw new TypeError("Super expression must either be null or a function");
        }
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return _construct(Class, arguments, _get_prototype_of(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return _set_prototype_of(Wrapper, Class);
    };
    return _wrap_native_super(Class);
}
function _is_native_reflect_construct() {
    try {
        var result = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (_) {}
    return (_is_native_reflect_construct = function() {
        return !!result;
    })();
}
var WebAuthnError = /*#__PURE__*/ function(Error1) {
    _inherits(WebAuthnError, Error1);
    function WebAuthnError(param) {
        var message = param.message, code = param.code, cause = param.cause, name = param.name;
        var _this;
        // @ts-ignore: help Rollup understand that `cause` is okay to set
        _this = Error1.call(this, message, {
            cause: cause
        }) || this;
        Object.defineProperty(_this, "code", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        _this.name = name != null ? name : cause.name;
        _this.code = code;
        return _this;
    }
    return WebAuthnError;
}(_wrap_native_super(Error));

function _instanceof$2(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return !!right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}
/**
 * Attempt to intuit _why_ an error was raised after calling `navigator.credentials.create()`
 */ function identifyRegistrationError(param) {
    var error = param.error, options = param.options;
    var publicKey = options.publicKey;
    if (!publicKey) {
        throw Error('options was missing required publicKey property');
    }
    if (error.name === 'AbortError') {
        if (_instanceof$2(options.signal, AbortSignal)) {
            // https://www.w3.org/TR/webauthn-2/#sctn-createCredential (Step 16)
            return new WebAuthnError({
                message: 'Registration ceremony was sent an abort signal',
                code: 'ERROR_CEREMONY_ABORTED',
                cause: error
            });
        }
    } else if (error.name === 'ConstraintError') {
        var _publicKey_authenticatorSelection, _publicKey_authenticatorSelection1, _publicKey_authenticatorSelection2;
        if (((_publicKey_authenticatorSelection = publicKey.authenticatorSelection) == null ? void 0 : _publicKey_authenticatorSelection.requireResidentKey) === true) {
            // https://www.w3.org/TR/webauthn-2/#sctn-op-make-cred (Step 4)
            return new WebAuthnError({
                message: 'Discoverable credentials were required but no available authenticator supported it',
                code: 'ERROR_AUTHENTICATOR_MISSING_DISCOVERABLE_CREDENTIAL_SUPPORT',
                cause: error
            });
        } else if (// @ts-ignore: `mediation` doesn't yet exist on CredentialCreationOptions but it's possible as of Sept 2024
        options.mediation === 'conditional' && ((_publicKey_authenticatorSelection1 = publicKey.authenticatorSelection) == null ? void 0 : _publicKey_authenticatorSelection1.userVerification) === 'required') {
            // https://w3c.github.io/webauthn/#sctn-createCredential (Step 22.4)
            return new WebAuthnError({
                message: 'User verification was required during automatic registration but it could not be performed',
                code: 'ERROR_AUTO_REGISTER_USER_VERIFICATION_FAILURE',
                cause: error
            });
        } else if (((_publicKey_authenticatorSelection2 = publicKey.authenticatorSelection) == null ? void 0 : _publicKey_authenticatorSelection2.userVerification) === 'required') {
            // https://www.w3.org/TR/webauthn-2/#sctn-op-make-cred (Step 5)
            return new WebAuthnError({
                message: 'User verification was required but no available authenticator supported it',
                code: 'ERROR_AUTHENTICATOR_MISSING_USER_VERIFICATION_SUPPORT',
                cause: error
            });
        }
    } else if (error.name === 'InvalidStateError') {
        // https://www.w3.org/TR/webauthn-2/#sctn-createCredential (Step 20)
        // https://www.w3.org/TR/webauthn-2/#sctn-op-make-cred (Step 3)
        return new WebAuthnError({
            message: 'The authenticator was previously registered',
            code: 'ERROR_AUTHENTICATOR_PREVIOUSLY_REGISTERED',
            cause: error
        });
    } else if (error.name === 'NotAllowedError') {
        /**
         * Pass the error directly through. Platforms are overloading this error beyond what the spec
         * defines and we don't want to overwrite potentially useful error messages.
         */ return new WebAuthnError({
            message: error.message,
            code: 'ERROR_PASSTHROUGH_SEE_CAUSE_PROPERTY',
            cause: error
        });
    } else if (error.name === 'NotSupportedError') {
        var validPubKeyCredParams = publicKey.pubKeyCredParams.filter(function(param) {
            return param.type === 'public-key';
        });
        if (validPubKeyCredParams.length === 0) {
            // https://www.w3.org/TR/webauthn-2/#sctn-createCredential (Step 10)
            return new WebAuthnError({
                message: 'No entry in pubKeyCredParams was of type "public-key"',
                code: 'ERROR_MALFORMED_PUBKEYCREDPARAMS',
                cause: error
            });
        }
        // https://www.w3.org/TR/webauthn-2/#sctn-op-make-cred (Step 2)
        return new WebAuthnError({
            message: 'No available authenticator supported any of the specified pubKeyCredParams algorithms',
            code: 'ERROR_AUTHENTICATOR_NO_SUPPORTED_PUBKEYCREDPARAMS_ALG',
            cause: error
        });
    } else if (error.name === 'SecurityError') {
        var effectiveDomain = globalThis.location.hostname;
        if (!isValidDomain(effectiveDomain)) {
            // https://www.w3.org/TR/webauthn-2/#sctn-createCredential (Step 7)
            return new WebAuthnError({
                message: "" + globalThis.location.hostname + " is an invalid domain",
                code: 'ERROR_INVALID_DOMAIN',
                cause: error
            });
        } else if (publicKey.rp.id !== effectiveDomain) {
            // https://www.w3.org/TR/webauthn-2/#sctn-createCredential (Step 8)
            return new WebAuthnError({
                message: 'The RP ID "' + publicKey.rp.id + '" is invalid for this domain',
                code: 'ERROR_INVALID_RP_ID',
                cause: error
            });
        }
    } else if (error.name === 'TypeError') {
        if (publicKey.user.id.byteLength < 1 || publicKey.user.id.byteLength > 64) {
            // https://www.w3.org/TR/webauthn-2/#sctn-createCredential (Step 5)
            return new WebAuthnError({
                message: 'User ID was not between 1 and 64 characters',
                code: 'ERROR_INVALID_USER_ID_LENGTH',
                cause: error
            });
        }
    } else if (error.name === 'UnknownError') {
        // https://www.w3.org/TR/webauthn-2/#sctn-op-make-cred (Step 1)
        // https://www.w3.org/TR/webauthn-2/#sctn-op-make-cred (Step 8)
        return new WebAuthnError({
            message: 'The authenticator was unable to process the specified options, or could not create a new credential',
            code: 'ERROR_AUTHENTICATOR_GENERAL_ERROR',
            cause: error
        });
    }
    return error;
}

var BaseWebAuthnAbortService = /*#__PURE__*/ function() {
    function BaseWebAuthnAbortService() {
        Object.defineProperty(this, "controller", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
    }
    var _proto = BaseWebAuthnAbortService.prototype;
    _proto.createNewAbortSignal = function createNewAbortSignal() {
        // Abort any existing calls to navigator.credentials.create() or navigator.credentials.get()
        if (this.controller) {
            var abortError = new Error('Cancelling existing WebAuthn API call for new one');
            abortError.name = 'AbortError';
            this.controller.abort(abortError);
        }
        var newController = new AbortController();
        this.controller = newController;
        return newController.signal;
    };
    _proto.cancelCeremony = function cancelCeremony() {
        if (this.controller) {
            var abortError = new Error('Manually cancelling existing WebAuthn API call');
            abortError.name = 'AbortError';
            this.controller.abort(abortError);
            this.controller = undefined;
        }
    };
    return BaseWebAuthnAbortService;
}();
/**
 * A service singleton to help ensure that only a single WebAuthn ceremony is active at a time.
 *
 * Users of **@simplewebauthn/browser** shouldn't typically need to use this, but it can help e.g.
 * developers building projects that use client-side routing to better control the behavior of
 * their UX in response to router navigation events.
 */ var WebAuthnAbortService = new BaseWebAuthnAbortService();

var attachments = [
    'cross-platform',
    'platform'
];
/**
 * If possible coerce a `string` value into a known `AuthenticatorAttachment`
 */ function toAuthenticatorAttachment(attachment) {
    if (!attachment) {
        return;
    }
    if (attachments.indexOf(attachment) < 0) {
        return;
    }
    return attachment;
}

function asyncGeneratorStep$2(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator$2(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep$2(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep$2(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _extends$1() {
    _extends$1 = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends$1.apply(this, arguments);
}
function _ts_generator$2(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
/**
 * Begin authenticator "registration" via WebAuthn attestation
 *
 * @param optionsJSON Output from **@simplewebauthn/server**'s `generateRegistrationOptions()`
 * @param useAutoRegister (Optional) Try to silently create a passkey with the password manager that the user just signed in with. Defaults to `false`.
 */ function startRegistration(options) {
    return _startRegistration.apply(this, arguments);
}
function _startRegistration() {
    _startRegistration = _async_to_generator$2(function(options) {
        var _optionsJSON_excludeCredentials, optionsJSON, _options_useAutoRegister, useAutoRegister, publicKey, createOptions, credential, err, id, rawId, response, type, transports, responsePublicKeyAlgorithm, responsePublicKey, _publicKey, responseAuthenticatorData;
        return _ts_generator$2(this, function(_state) {
            switch(_state.label){
                case 0:
                    // @ts-ignore: Intentionally check for old call structure to warn about improper API call
                    if (!options.optionsJSON && options.challenge) {
                        console.warn('startRegistration() was not called correctly. It will try to continue with the provided options, but this call should be refactored to use the expected call structure instead. See https://simplewebauthn.dev/docs/packages/browser#typeerror-cannot-read-properties-of-undefined-reading-challenge for more information.');
                        // @ts-ignore: Reassign the options, passed in as a positional argument, to the expected variable
                        options = {
                            optionsJSON: options
                        };
                    }
                    optionsJSON = options.optionsJSON, _options_useAutoRegister = options.useAutoRegister, useAutoRegister = _options_useAutoRegister === void 0 ? false : _options_useAutoRegister;
                    if (!browserSupportsWebAuthn()) {
                        throw new Error('WebAuthn is not supported in this browser');
                    }
                    // We need to convert some values to Uint8Arrays before passing the credentials to the navigator
                    publicKey = _extends$1({}, optionsJSON, {
                        challenge: base64URLStringToBuffer(optionsJSON.challenge),
                        user: _extends$1({}, optionsJSON.user, {
                            id: base64URLStringToBuffer(optionsJSON.user.id)
                        }),
                        excludeCredentials: (_optionsJSON_excludeCredentials = optionsJSON.excludeCredentials) == null ? void 0 : _optionsJSON_excludeCredentials.map(toPublicKeyCredentialDescriptor)
                    });
                    // Prepare options for `.create()`
                    createOptions = {};
                    /**
     * Try to use conditional create to register a passkey for the user with the password manager
     * the user just used to authenticate with. The user won't be shown any prominent UI by the
     * browser.
     */ if (useAutoRegister) {
                        // @ts-ignore: `mediation` doesn't yet exist on CredentialCreationOptions but it's possible as of Sept 2024
                        createOptions.mediation = 'conditional';
                    }
                    // Finalize options
                    createOptions.publicKey = publicKey;
                    // Set up the ability to cancel this request if the user attempts another
                    createOptions.signal = WebAuthnAbortService.createNewAbortSignal();
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        navigator.credentials.create(createOptions)
                    ];
                case 2:
                    credential = _state.sent();
                    return [
                        3,
                        4
                    ];
                case 3:
                    err = _state.sent();
                    throw identifyRegistrationError({
                        error: err,
                        options: createOptions
                    });
                case 4:
                    if (!credential) {
                        throw new Error('Registration was not completed');
                    }
                    id = credential.id, rawId = credential.rawId, response = credential.response, type = credential.type;
                    // Continue to play it safe with `getTransports()` for now, even when L3 types say it's required
                    transports = undefined;
                    if (typeof response.getTransports === 'function') {
                        transports = response.getTransports();
                    }
                    // L3 says this is required, but browser and webview support are still not guaranteed.
                    responsePublicKeyAlgorithm = undefined;
                    if (typeof response.getPublicKeyAlgorithm === 'function') {
                        try {
                            responsePublicKeyAlgorithm = response.getPublicKeyAlgorithm();
                        } catch (error) {
                            warnOnBrokenImplementation('getPublicKeyAlgorithm()', error);
                        }
                    }
                    responsePublicKey = undefined;
                    if (typeof response.getPublicKey === 'function') {
                        try {
                            _publicKey = response.getPublicKey();
                            if (_publicKey !== null) {
                                responsePublicKey = bufferToBase64URLString(_publicKey);
                            }
                        } catch (error) {
                            warnOnBrokenImplementation('getPublicKey()', error);
                        }
                    }
                    if (typeof response.getAuthenticatorData === 'function') {
                        try {
                            responseAuthenticatorData = bufferToBase64URLString(response.getAuthenticatorData());
                        } catch (error) {
                            warnOnBrokenImplementation('getAuthenticatorData()', error);
                        }
                    }
                    return [
                        2,
                        {
                            id: id,
                            rawId: bufferToBase64URLString(rawId),
                            response: {
                                attestationObject: bufferToBase64URLString(response.attestationObject),
                                clientDataJSON: bufferToBase64URLString(response.clientDataJSON),
                                transports: transports,
                                publicKeyAlgorithm: responsePublicKeyAlgorithm,
                                publicKey: responsePublicKey,
                                authenticatorData: responseAuthenticatorData
                            },
                            type: type,
                            clientExtensionResults: credential.getClientExtensionResults(),
                            authenticatorAttachment: toAuthenticatorAttachment(credential.authenticatorAttachment)
                        }
                    ];
            }
        });
    });
    return _startRegistration.apply(this, arguments);
}
/**
 * Visibly warn when we detect an issue related to a passkey provider intercepting WebAuthn API
 * calls
 */ function warnOnBrokenImplementation(methodName, cause) {
    console.warn("The browser extension that intercepted this WebAuthn API call incorrectly implemented " + methodName + ". You should report this error to them.\n", cause);
}

/**
 * Determine if the browser supports conditional UI, so that WebAuthn credentials can
 * be shown to the user in the browser's typical password autofill popup.
 */ function browserSupportsWebAuthnAutofill() {
    if (!browserSupportsWebAuthn()) {
        return _browserSupportsWebAuthnAutofillInternals.stubThis(new Promise(function(resolve) {
            return resolve(false);
        }));
    }
    /**
     * I don't like the `as unknown` here but there's a `declare var PublicKeyCredential` in
     * TS' DOM lib that's making it difficult for me to just go `as PublicKeyCredentialFuture` as I
     * want. I think I'm fine with this for now since it's _supposed_ to be temporary, until TS types
     * have a chance to catch up.
     */ var globalPublicKeyCredential = globalThis.PublicKeyCredential;
    if ((globalPublicKeyCredential == null ? void 0 : globalPublicKeyCredential.isConditionalMediationAvailable) === undefined) {
        return _browserSupportsWebAuthnAutofillInternals.stubThis(new Promise(function(resolve) {
            return resolve(false);
        }));
    }
    return _browserSupportsWebAuthnAutofillInternals.stubThis(globalPublicKeyCredential.isConditionalMediationAvailable());
}
// Make it possible to stub the return value during testing
var _browserSupportsWebAuthnAutofillInternals = {
    stubThis: function(value) {
        return value;
    }
};

function _instanceof$1(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return !!right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}
/**
 * Attempt to intuit _why_ an error was raised after calling `navigator.credentials.get()`
 */ function identifyAuthenticationError(param) {
    var error = param.error, options = param.options;
    var publicKey = options.publicKey;
    if (!publicKey) {
        throw Error('options was missing required publicKey property');
    }
    if (error.name === 'AbortError') {
        if (_instanceof$1(options.signal, AbortSignal)) {
            // https://www.w3.org/TR/webauthn-2/#sctn-createCredential (Step 16)
            return new WebAuthnError({
                message: 'Authentication ceremony was sent an abort signal',
                code: 'ERROR_CEREMONY_ABORTED',
                cause: error
            });
        }
    } else if (error.name === 'NotAllowedError') {
        /**
         * Pass the error directly through. Platforms are overloading this error beyond what the spec
         * defines and we don't want to overwrite potentially useful error messages.
         */ return new WebAuthnError({
            message: error.message,
            code: 'ERROR_PASSTHROUGH_SEE_CAUSE_PROPERTY',
            cause: error
        });
    } else if (error.name === 'SecurityError') {
        var effectiveDomain = globalThis.location.hostname;
        if (!isValidDomain(effectiveDomain)) {
            // https://www.w3.org/TR/webauthn-2/#sctn-discover-from-external-source (Step 5)
            return new WebAuthnError({
                message: "" + globalThis.location.hostname + " is an invalid domain",
                code: 'ERROR_INVALID_DOMAIN',
                cause: error
            });
        } else if (publicKey.rpId !== effectiveDomain) {
            // https://www.w3.org/TR/webauthn-2/#sctn-discover-from-external-source (Step 6)
            return new WebAuthnError({
                message: 'The RP ID "' + publicKey.rpId + '" is invalid for this domain',
                code: 'ERROR_INVALID_RP_ID',
                cause: error
            });
        }
    } else if (error.name === 'UnknownError') {
        // https://www.w3.org/TR/webauthn-2/#sctn-op-get-assertion (Step 1)
        // https://www.w3.org/TR/webauthn-2/#sctn-op-get-assertion (Step 12)
        return new WebAuthnError({
            message: 'The authenticator was unable to process the specified options, or could not create a new assertion signature',
            code: 'ERROR_AUTHENTICATOR_GENERAL_ERROR',
            cause: error
        });
    }
    return error;
}

function asyncGeneratorStep$1(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator$1(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep$1(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep$1(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _ts_generator$1(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
/**
 * Begin authenticator "login" via WebAuthn assertion
 *
 * @param optionsJSON Output from **@simplewebauthn/server**'s `generateAuthenticationOptions()`
 * @param useBrowserAutofill (Optional) Initialize conditional UI to enable logging in via browser autofill prompts. Defaults to `false`.
 * @param verifyBrowserAutofillInput (Optional) Ensure a suitable `<input>` element is present when `useBrowserAutofill` is `true`. Defaults to `true`.
 */ function startAuthentication(options) {
    return _startAuthentication.apply(this, arguments);
}
function _startAuthentication() {
    _startAuthentication = _async_to_generator$1(function(options) {
        var _optionsJSON_allowCredentials, optionsJSON, _options_useBrowserAutofill, useBrowserAutofill, _options_verifyBrowserAutofillInput, verifyBrowserAutofillInput, allowCredentials, _optionsJSON_allowCredentials1, publicKey, getOptions, eligibleInputs, credential, err, id, rawId, response, type, userHandle;
        return _ts_generator$1(this, function(_state) {
            switch(_state.label){
                case 0:
                    // @ts-ignore: Intentionally check for old call structure to warn about improper API call
                    if (!options.optionsJSON && options.challenge) {
                        console.warn('startAuthentication() was not called correctly. It will try to continue with the provided options, but this call should be refactored to use the expected call structure instead. See https://simplewebauthn.dev/docs/packages/browser#typeerror-cannot-read-properties-of-undefined-reading-challenge for more information.');
                        // @ts-ignore: Reassign the options, passed in as a positional argument, to the expected variable
                        options = {
                            optionsJSON: options
                        };
                    }
                    optionsJSON = options.optionsJSON, _options_useBrowserAutofill = options.useBrowserAutofill, useBrowserAutofill = _options_useBrowserAutofill === void 0 ? false : _options_useBrowserAutofill, _options_verifyBrowserAutofillInput = options.verifyBrowserAutofillInput, verifyBrowserAutofillInput = _options_verifyBrowserAutofillInput === void 0 ? true : _options_verifyBrowserAutofillInput;
                    if (!browserSupportsWebAuthn()) {
                        throw new Error('WebAuthn is not supported in this browser');
                    }
                    if (((_optionsJSON_allowCredentials = optionsJSON.allowCredentials) == null ? void 0 : _optionsJSON_allowCredentials.length) !== 0) {
                        allowCredentials = (_optionsJSON_allowCredentials1 = optionsJSON.allowCredentials) == null ? void 0 : _optionsJSON_allowCredentials1.map(toPublicKeyCredentialDescriptor);
                    }
                    // We need to convert some values to Uint8Arrays before passing the credentials to the navigator
                    publicKey = _extends({}, optionsJSON, {
                        challenge: base64URLStringToBuffer(optionsJSON.challenge),
                        allowCredentials: allowCredentials
                    });
                    // Prepare options for `.get()`
                    getOptions = {};
                    if (!useBrowserAutofill) return [
                        3,
                        2
                    ];
                    return [
                        4,
                        browserSupportsWebAuthnAutofill()
                    ];
                case 1:
                    if (!_state.sent()) {
                        throw Error('Browser does not support WebAuthn autofill');
                    }
                    // Check for an <input> with "webauthn" in its `autocomplete` attribute
                    eligibleInputs = document.querySelectorAll("input[autocomplete$='webauthn']");
                    // WebAuthn autofill requires at least one valid input
                    if (eligibleInputs.length < 1 && verifyBrowserAutofillInput) {
                        throw Error('No <input> with "webauthn" as the only or last value in its `autocomplete` attribute was detected');
                    }
                    // `CredentialMediationRequirement` doesn't know about "conditional" yet as of
                    // typescript@4.6.3
                    getOptions.mediation = 'conditional';
                    // Conditional UI requires an empty allow list
                    publicKey.allowCredentials = [];
                    _state.label = 2;
                case 2:
                    // Finalize options
                    getOptions.publicKey = publicKey;
                    // Set up the ability to cancel this request if the user attempts another
                    getOptions.signal = WebAuthnAbortService.createNewAbortSignal();
                    _state.label = 3;
                case 3:
                    _state.trys.push([
                        3,
                        5,
                        ,
                        6
                    ]);
                    return [
                        4,
                        navigator.credentials.get(getOptions)
                    ];
                case 4:
                    credential = _state.sent();
                    return [
                        3,
                        6
                    ];
                case 5:
                    err = _state.sent();
                    throw identifyAuthenticationError({
                        error: err,
                        options: getOptions
                    });
                case 6:
                    if (!credential) {
                        throw new Error('Authentication was not completed');
                    }
                    id = credential.id, rawId = credential.rawId, response = credential.response, type = credential.type;
                    userHandle = undefined;
                    if (response.userHandle) {
                        userHandle = bufferToBase64URLString(response.userHandle);
                    }
                    // Convert values to base64 to make it easier to send back to the server
                    return [
                        2,
                        {
                            id: id,
                            rawId: bufferToBase64URLString(rawId),
                            response: {
                                authenticatorData: bufferToBase64URLString(response.authenticatorData),
                                clientDataJSON: bufferToBase64URLString(response.clientDataJSON),
                                signature: bufferToBase64URLString(response.signature),
                                userHandle: userHandle
                            },
                            type: type,
                            clientExtensionResults: credential.getClientExtensionResults(),
                            authenticatorAttachment: toAuthenticatorAttachment(credential.authenticatorAttachment)
                        }
                    ];
            }
        });
    });
    return _startAuthentication.apply(this, arguments);
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _instanceof(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return !!right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var PasskeyWeb = /*#__PURE__*/ function() {
    function PasskeyWeb() {}
    PasskeyWeb.withCeremonyTimeout = function withCeremonyTimeout(promise, timeoutMs) {
        if (timeoutMs === void 0) timeoutMs = PasskeyWeb.DEFAULT_CEREMONY_TIMEOUT_MS;
        return _async_to_generator(function() {
            var timeoutHandle, timeoutPromise;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!timeoutMs || timeoutMs <= 0) {
                            return [
                                2,
                                promise
                            ];
                        }
                        timeoutPromise = new Promise(function(_, reject) {
                            timeoutHandle = setTimeout(function() {
                                try {
                                    WebAuthnAbortService.cancelCeremony();
                                } catch (e) {
                                // ignore
                                }
                                reject(new Error('Passkey request timed out'));
                            }, timeoutMs);
                        });
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            ,
                            3,
                            4
                        ]);
                        return [
                            4,
                            Promise.race([
                                promise,
                                timeoutPromise
                            ])
                        ];
                    case 2:
                        return [
                            2,
                            _state.sent()
                        ];
                    case 3:
                        if (timeoutHandle) {
                            clearTimeout(timeoutHandle);
                        }
                        return [
                            7
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        })();
    };
    /**
     * Start passkey registration using WebAuthn
     * @param options - The challenge options received from the server
     * @returns Promise with the registration response containing the credential
     */ PasskeyWeb.startRegistration = function startRegistration1(options) {
        return _async_to_generator(function() {
            var responseJSON, error;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        // Check if WebAuthn is supported
                        if (!browserSupportsWebAuthn()) {
                            return [
                                2,
                                {
                                    success: false,
                                    error: 'WebAuthn is not supported in this browser'
                                }
                            ];
                        }
                        return [
                            4,
                            PasskeyWeb.withCeremonyTimeout(startRegistration({
                                optionsJSON: options
                            }))
                        ];
                    case 1:
                        responseJSON = _state.sent();
                        return [
                            2,
                            {
                                success: true,
                                responseJSON: responseJSON
                            }
                        ];
                    case 2:
                        error = _state.sent();
                        // Handle user cancellation
                        if (_instanceof(error, Error) && error.name === 'NotAllowedError') {
                            return [
                                2,
                                {
                                    success: false,
                                    error: 'User cancelled the registration'
                                }
                            ];
                        }
                        // Handle other errors
                        return [
                            2,
                            {
                                success: false,
                                error: _instanceof(error, Error) ? error.message : 'Failed to register passkey'
                            }
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        })();
    };
    /**
     * Start passkey authentication using WebAuthn
     * @param options - The challenge options received from the server
     * @param useConditionalMediation - If true, uses conditional UI (autofill) for passkey selection
     * @returns Promise with the authentication response containing the credential
     */ PasskeyWeb.startAuthentication = function startAuthentication1(options, useConditionalMediation) {
        if (useConditionalMediation === void 0) useConditionalMediation = false;
        return _async_to_generator(function() {
            var responseJSON, error;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        // Check if WebAuthn is supported
                        if (!browserSupportsWebAuthn()) {
                            return [
                                2,
                                {
                                    success: false,
                                    error: 'WebAuthn is not supported in this browser'
                                }
                            ];
                        }
                        return [
                            4,
                            PasskeyWeb.withCeremonyTimeout(startAuthentication({
                                optionsJSON: options,
                                useBrowserAutofill: useConditionalMediation,
                                verifyBrowserAutofillInput: useConditionalMediation
                            }))
                        ];
                    case 1:
                        responseJSON = _state.sent();
                        return [
                            2,
                            {
                                success: true,
                                responseJSON: responseJSON
                            }
                        ];
                    case 2:
                        error = _state.sent();
                        // Handle abort
                        if (_instanceof(error, Error) && error.name === 'AbortError') {
                            return [
                                2,
                                {
                                    success: false,
                                    error: 'Authentication was cancelled'
                                }
                            ];
                        }
                        // Handle user cancellation
                        if (_instanceof(error, Error) && error.name === 'NotAllowedError') {
                            return [
                                2,
                                {
                                    success: false,
                                    error: 'User cancelled the authentication'
                                }
                            ];
                        }
                        // Handle other errors
                        return [
                            2,
                            {
                                success: false,
                                error: _instanceof(error, Error) ? error.message : 'Failed to authenticate with passkey'
                            }
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        })();
    };
    /**
     * Check if passkey/WebAuthn is supported in the current browser
     * Uses the browserSupportsWebAuthn helper from @simplewebauthn/browser
     * @returns boolean indicating support
     */ PasskeyWeb.isSupported = function isSupported() {
        return browserSupportsWebAuthn();
    };
    /**
     * Check if the browser supports passkey autofill (conditional UI)
     * @returns Promise<boolean> indicating autofill support
     */ PasskeyWeb.supportsAutofill = function supportsAutofill() {
        return _async_to_generator(function() {
            var available;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        if (!window.PublicKeyCredential) {
                            return [
                                2,
                                false
                            ];
                        }
                        return [
                            4,
                            PublicKeyCredential.isConditionalMediationAvailable()
                        ];
                    case 1:
                        available = _state.sent();
                        return [
                            2,
                            available
                        ];
                    case 2:
                        _state.sent();
                        return [
                            2,
                            false
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        })();
    };
    /**
     * Abort any ongoing passkey request (registration or authentication)
     * This is useful for canceling autofill authentication when user navigates away
     */ PasskeyWeb.abortPasskeyRequest = function abortPasskeyRequest() {
        WebAuthnAbortService.cancelCeremony();
    };
    return PasskeyWeb;
}();
/**
     * Default timeout for WebAuthn ceremonies (registration/authentication).
     * This prevents indefinite "waiting" states on older/buggy platforms.
     */ PasskeyWeb.DEFAULT_CEREMONY_TIMEOUT_MS = 180000;

export { PasskeyWeb };
